module.exports = __webpack_public_path__ + "img/video-xunjian.eadf654e.jpg";